module.exports = __webpack_public_path__ + "static/media/workfolio-latest-old.c692be21.png";